import { cn } from '@solinkcorp/solink-ui';
import type { RefObject } from 'react';
import { CELL_HEIGHT_PX } from '../../constants';

interface DayPartGridLinesProps {
  index: number;
  isWeekView: boolean;
  scrollTargetRef?: RefObject<HTMLDivElement>;
  targetScrollHour?: number;
}

export const DayPartGridLines = (props: DayPartGridLinesProps) => {
  const { index, isWeekView, scrollTargetRef, targetScrollHour } = props;
  const isScrollTarget = scrollTargetRef != null && targetScrollHour === index;

  return (
    <div
      className={cn('inline-flex', isWeekView ? 'w-[74px]' : 'w-full')}
      style={{ height: `${CELL_HEIGHT_PX}px` }}
      ref={isScrollTarget ? scrollTargetRef : undefined}
    >
      <div className="h-full w-full border-t border-border-muted" />
    </div>
  );
};
